import { render, staticRenderFns } from "./FamilyAccounts.vue?vue&type=template&id=2595bde2&scoped=true"
import script from "./FamilyAccounts.vue?vue&type=script&lang=js"
export * from "./FamilyAccounts.vue?vue&type=script&lang=js"
import style0 from "./FamilyAccounts.vue?vue&type=style&index=0&id=2595bde2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2595bde2",
  null
  
)

export default component.exports